<template>
	<div class="resume-map">
		<google-map :reading="reading" :zones="zones.data"/>
		<spinner v-if="zones.loading" class="spinner"/>
	</div>
</template>

<script>
import GoogleMapsLoader from 'google-maps'
import Readings from '@/utils/readings'
import GoogleMap from '@/components/maps/GoogleMap'
export default {
	components: {
		GoogleMap
	},
	props: [
		'user_uid',
		'watch_id',
		'resume'
	],
	data () {
		return {
			zones: {
				loading: false,
				error: null,
				data: []
			}
		}
	},
	computed: {
		reading () {
			return {
				date: this.resume.values.first.date,
				position: [ this.resume.values.first.latitude, this.resume.values.first.longitude ]
			}
		}
	},
	methods: {
		getZones () {
			this.zones.loading = true
			this.zones.data = []
			this.$api.geofencing.getAll(this, this.user_uid, this.watch_id)
				.then(response => {
					this.$log.info('watch geofencing resume map', 'geofencing.getAll OK', response)()
					this.zones.data = Readings.processZones(response.body)
				}).catch(error => {
					this.$log.error('watch geofencing resume map', 'geofencing.getAll ERROR', error)()
					this.zones.error = error
				}).finally(() => {
					this.zones.loading = false
				})
		}
	},
	mounted () {
		GoogleMapsLoader.KEY = this.$root.settings.googleMapsKey
		GoogleMapsLoader.LIBRARIES = this.$root.settings.googleMapsLibraries
		GoogleMapsLoader.load(() => {
			this.getZones()
		})
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/shared/alerts/ResumeMap.vue